// PG-1 period selector — the single source for the analysis window that drives
// Strength (e1RM), Rhythm (the weekly-frequency chart) and the "More detail"
// panels. Coverage + Alerts + the bodymap + the session-count stat grid are
// deliberately NOT driven by it (Coverage is weekly by nature; Alerts is a
// fixed baseline comparison; the stat grid is a fixed multi-window census).
//
// One home for the option list + default + the rhythm re-bucketing so the
// selector, ProgressView and every panel agree on the same numbers.

/** Default window on cold load. 90d ≈ the pre-selector Strength view (12 wk)
 *  and matches density's existing 90d, so the family's first paint barely
 *  moves; the selector then re-windows everything together on tap. */
export const DEFAULT_WINDOW_DAYS = 90;

/** The offered presets. `custom` (a free numeric window) is deliberately
 *  deferred — see next/backlog.md §PG. */
export const PERIOD_OPTIONS: readonly number[] = [7, 14, 30, 90];

/** Rhythm chart re-bucketing: a `windowDays` window shows the trailing
 *  ⌈windowDays / 7⌉ weekly bars (min 1). At 90d → 13 (capped by the host's
 *  12-week history); at 7d → a single bar. */
export const rhythmBarCount = (windowDays: number): number =>
  Math.max(1, Math.ceil(windowDays / 7));
